import { defineStore } from 'pinia'
import { ref } from 'vue'
import { PortalRoleType } from '@/enums/portal/portalRoleType'
import userService from '@/services/user.service'

export const useTpoPortalRoleStore = defineStore('tpoPortalRole', () => {
  const currentSelection = ref<PortalRoleType>(PortalRoleType.BROKER)
  const isProcessorManager = ref<boolean>(false)

  const setCurrentSelection = (selection: PortalRoleType) => {
    currentSelection.value = selection
    isProcessorManager.value = selection === PortalRoleType.PROCESSOR_MANAGER ? true : false
  }

  const getIsProcessorManager = () => {
    return isProcessorManager.value
  }

  const getCurrentRole = () => {
    return currentSelection.value
  }

  const verifyTpoPortalRole = async (userId: string) => {
    const response = await userService.getUser(userId || '')

    if (response.data.user.tpoPortalRole === PortalRoleType.PROCESSOR_MANAGER) {
      setCurrentSelection(PortalRoleType.PROCESSOR_MANAGER)
      return true
    } else {
      setCurrentSelection(PortalRoleType.BROKER)
      return false
    }
  }

  const switchPortalRole = async (userId: string, role: PortalRoleType) => {
    const response = await userService.switchPortalRole(userId, role)

    if (response.success) {
      if (response.data.currentPortalRole === PortalRoleType.PROCESSOR_MANAGER) {
        setCurrentSelection(PortalRoleType.PROCESSOR_MANAGER)
      } else {
        setCurrentSelection(PortalRoleType.BROKER)
      }
      console.log("CELSOOOO", response)
      return response
    } else {
      throw new Error(response.message || 'Failed to switch role')
    }
  }

  const fetchPortalRole = async (userId: string) => {
    if (!userId) {
      return null
    }

    const response = await userService.getUserPortalRole(userId)

    return response.data.currentPortalRole
  }

  return {
    getCurrentRole,
    switchPortalRole,
    setCurrentSelection,
    verifyTpoPortalRole,
    getIsProcessorManager,
    fetchPortalRole,
  }
})